<main class="agpr-landingPage">
    <h1 class="u-srOnly">{{ 'Dashboard.heading' | localize }}</h1>
    <div class="agpr-landingPage-layout">
        <agpr-scroll-panel>
            <section
                class="agpr-landingPage-section"
                [ngClass]="{'agpr-landingPage-section-reseller': isReseller}"
            >
                    @if (showWelcomeMessage && !isImpersonating) {
                        <div class="agpr-landingPage-section-banner">
                            <div class="agpr-landingPage-section-bannerMessage">
                                {{ landingPageWelcomeMessage }}
                            </div>
                        </div>
                    }
                    @if (hasAnyModulePermissions) {
                        <div class="agpr-landingPage-section-recentActivities">
                            <agpr-recent-activities
                                [id]="id"
                                [recentActivities]="recentActivities"
                                [userRecentActivities]="userRecentActivities"
                                [loading]="loading"
                                [isReseller]="isReseller"
                            ></agpr-recent-activities>
                        </div>
                    }
                    @for (feature of sortedFeatures; track feature.id) {
                        <div
                            class="agpr-landingPage-section-container"
                            [ngClass]=" feature.hasPermission ?
                                {
                                    'agpr-landingPage-section-featureReseller': isReseller,
                                    'agpr-landingPage-section-mediaIntelligence-permission': feature.id === 'primaryNavMediaIntelligence',
                                    'agpr-landingPage-section-mediaRelations-permission': feature.id === 'primaryNavMediaRelations',
                                    'agpr-landingPage-section-social-permission': feature.id === 'primaryNavSocial'
                                }
                                : {
                                    'agpr-landingPage-section-mediaIntelligence-noPermission': feature.id === 'primaryNavMediaIntelligence',
                                    'agpr-landingPage-section-mediaRelations-noPermission': feature.id === 'primaryNavMediaRelations',
                                    'agpr-landingPage-section-social-noPermission': feature.id === 'primaryNavSocial'
                                }
                            "
                            id="{{id}}.{{feature.id}}"
                        >
                            <agpr-product-features
                                [id]="id"
                                [header]="feature.label"
                                [featureId]="feature.id"
                                [subItems]="feature.hasPermission ? feature.items : null"
                                [featurePermission]="feature.hasPermission"
                                [upsellMessage]="feature.hasPermission ? null : feature.upsellMessage"
                            >
                            </agpr-product-features>
                        </div>
                    }
            </section>
        </agpr-scroll-panel>
        @if (!isReseller) {
            <aside class="agpr-landingPage-sidebar">
                <agpr-scroll-panel class="agpr-landingPage-sidebar-panel">
                    <div class="agpr-landingPage-sidebar-iframe">
                        <iframe
                            src="https://www.agilitypr.com/iframe/"
                            sandbox="allow-same-origin allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
                            scrolling="no"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                            [title]="'AgilityPRSoultions' | localize"
                        >
                        </iframe>
                    </div>
                    <div class="agpr-landingPage-sidebar-container">
                        <div class="agpr-landingPage-sidebar-container-helpCenter">
                            <agpr-landing-page-help-center
                                [id]="'LandingPage.helpCenter'"
                                [header]="'Dashboard.helpCenter.title'"
                                [description]="'Dashboard.helpCenter.text'"
                                [externalUrl]="'http://help.agilitypr.com/en/'"
                                [linkText]="'Dashboard.helpCenter.link'"
                            ></agpr-landing-page-help-center>
                        </div>
                        <div class="agpr-landingPage-sidebar-container-resources">
                            <agpr-landing-page-help-center
                                [id]="'LandingPage.prResources'"
                                [header]="'Dashboard.prResources.title'"
                                [description]="'Dashboard.prResources.description'"
                                [externalUrl]="'https://www.agilitypr.com/resources/'"
                                [linkText]="'Dashboard.prResources.linkText'"
                            ></agpr-landing-page-help-center>
                        </div>
                        <div class="agpr-landingPage-sidebar-container-agilityNews">
                            <agpr-landing-page-feed-reader
                                [id]="'LandingPage.newInAgility'"
                                [title]="'Dashboard.newInAgility.title'"
                                [icon]="'fa-kit-duotone fa-agpr-dash-new'"
                                [description]="'Dashboard.newInAgility.description'"
                                [feed]="'new-in-agility'"
                                [viewAll]="'https://www.agilitypr.com/agility-support-new-in-agility/'"
                                [isAgilityNews]="true"
                            ></agpr-landing-page-feed-reader>
                        </div>
                        <div class="agpr-landingPage-sidebar-container-prNews">
                            <agpr-landing-page-feed-reader
                                [id]="'LandingPage.prNews'"
                                [title]="'Dashboard.prNews.title'"
                                [feed]="'pr-news'"
                                [viewAll]="'https://www.agilitypr.com/pr-news/'"
                                [showAuthor]="true"
                                [isPrNews]="true"
                            ></agpr-landing-page-feed-reader>
                        </div>
                    </div>
                </agpr-scroll-panel>
            </aside>
        }
    </div>
</main>